














import Component from 'vue-class-component';
import PluginComponent from '../PluginComponent';
import Plugin from '@/models/plugin/Plugin';


@Component
export default class RedirectPlugin extends PluginComponent {
  static ID =  'RedirectPlugin'

  plugin!:Plugin;

  label = '';

  icon = '';

  url = '';

  newTab = false;

  created(){
  }

  mounted() {
    this.label = this.plugin.getParameterValue('nameRedirect');
    this.icon = this.plugin.getParameterValue('iconRedirect');
    this.url = this.plugin.getParameterValue('urlRedirect');
    this.newTab = this.plugin.getParameterValue('newTab');
  }

  redirect(): void {
    if (this.newTab) {
        window.open(this.url, '_blank');
    } else {
      window.location.href = this.url;
    }
  }


}
